import type { PodcastHostedVideo } from '@shared/dream-components';

import type { PodcastEpisode } from '~/interfaces/podcast';

export const getEpisodeHostedVideo = (podcastEpisode: PodcastEpisode): PodcastHostedVideo | undefined =>
  podcastEpisode.video ? { id: podcastEpisode.video.id, posterUrl: podcastEpisode.video.poster_url } : undefined;
